import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, Chip, ListItem, Menu } from "@mui/material";
import { GuyFawkesMask } from "mdi-material-ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { LoginButton, useAuth } from "./index.js";
export const AccountButton = ({ children, }) => {
    const { t } = useTranslation("AccountButton");
    const [anchorEl, setAnchorEl] = useState();
    const { user, signoutRedirect } = useAuth();
    if (!user) {
        return _jsx(LoginButton, {});
    }
    const impersonated_by = user.profile.impersonated_by?.toString();
    return (_jsxs(_Fragment, { children: [_jsx(Chip, { title: impersonated_by || undefined, icon: impersonated_by ? _jsx(GuyFawkesMask, { fontSize: "small" }) : undefined, label: user.profile.name, onClick: ({ currentTarget }) => setAnchorEl(currentTarget) }), _jsxs(Menu, { open: !!anchorEl, anchorEl: anchorEl, onClose: () => setAnchorEl(undefined), sx: { mt: 1 }, anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "right",
                }, transformOrigin: {
                    vertical: "top",
                    horizontal: "right",
                }, children: [children?.({ user, onClose: () => setAnchorEl(undefined) }), _jsx(ListItem, { dense: true, children: _jsx(Button, { variant: "contained", onClick: () => {
                                signoutRedirect();
                                setAnchorEl(undefined);
                            }, fullWidth: true, children: t("logout") }) })] })] }));
};
//# sourceMappingURL=AccountButton.js.map